"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollInfo = void 0;
// Breaking this out greatly improves unit testability since the
// bare element properties do not function as expected in the node-based
// jest unit test environment.
/**
 * A simple wrapper to get scroll properties from a dom element.
 **/
const getScrollInfo = element => {
  const info = {
    scrollTop: element.scrollTop,
    scrollLeft: element.scrollLeft,
    viewportHeight: element.clientHeight,
    viewportWidth: element.clientWidth,
    contentHeight: element.scrollHeight,
    contentWidth: element.scrollWidth
  };
  return info;
};
exports.getScrollInfo = getScrollInfo;
//# sourceMappingURL=scrollUtils.js.map